module.exports = __webpack_public_path__ + "img/1-1ZG0154135617 (1).98d9c455.png";